$(function () {
  var $modelCheckBoxes = $(".modelListingModelComponent-checkbox"),
    $compareBar = $(".compareComponent"),
    $compareList = $(".compareComponent-list"),
    $clearAll = $(".compareComponent-clear"),
    $compareLink = $(".compareComponent-compareLink"),
    itemsAddedToCompareBar = 0,
    pimIds = [];
  $modelCheckBoxes.on("click", handleClickOnCheckbox);
  $clearAll.on("click", clearAllItemsFromCompareBar);
  $compareBar.on("click", ".compareComponent-itemClear", clearItem(false));
  $compareLink.on("click", openCompareView);
  function handleClickOnCheckbox() {
    var $modelCheckbox = $(this);
    if (!$modelCheckbox.prop("checked")) {
      $modelCheckbox.prop("checked", false);
      clearItem($modelCheckbox)();
      updateLink();
      return;
    }
    if (itemsAddedToCompareBar === 0 && !$compareBar.hasClass("in-view")) {
      $compareBar.addClass("in-view");
    }
    if (itemsAddedToCompareBar <= 4) {
      addItemToCompareBar($modelCheckbox);
      addPimIds($modelCheckbox);
      itemsAddedToCompareBar++;
      updateText();
      updateTextNodeWithNumberOfItemsSelected();
    }
    if (itemsAddedToCompareBar === 4) {
      $modelCheckBoxes.not("input:checked").prop("disabled", true);
    }
    updateLink();
  }
  function updateTextNodeWithNumberOfItemsSelected() {
    if ($(window).width() < 767) {
      $(".compareComponent-compare .active").find("span").empty().append("(" + itemsAddedToCompareBar + ")");
    }
  }
  function clearAllItemsFromCompareBar() {
    pimIds = [];
    var $listItems = $(".compareComponent-list").children();
    $listItems.each(function (i, obj) {
      $(obj).removeClass("has-model").removeAttr("data-pim-id").find("div").empty();
    });
    itemsAddedToCompareBar = 0;
    $modelCheckBoxes.prop("disabled", false).prop("checked", false);
    $compareBar.removeClass("in-view");
    updateTextNodeWithNumberOfItemsSelected();
  }
  function clearItem($checkbox) {
    return function () {
      $modelCheckBoxes.prop("disabled", false);
      var pimId = !$checkbox ? $(this).closest(".compareComponent-listitem").data("pim-id") : $checkbox.closest(".modelListingModelComponent-checkboxWrapper").data("pim-id"),
        $modelCheckbox = !$checkbox ? $(".modelListingModelComponent").find("[data-pim-id='" + pimId + "']").find("input") : $checkbox,
        $compareModel = !$checkbox ? $(this).closest(".compareComponent-listitem") : $(".compareComponent-list").find("[data-pim-id='" + pimId + "']");
      updateView($modelCheckbox);
      $compareModel.remove();
      removePimIds($modelCheckbox);
      updateTextNodeWithNumberOfItemsSelected();
    };
  }
  function updateView($modelCheckbox) {
    $modelCheckbox.prop("checked", false);
    itemsAddedToCompareBar--;
    $compareList.append("<li class='compareComponent-listitem'><div class='compareComponent-imagewrapper'></div></li>");
    updateText();
    if (itemsAddedToCompareBar === 0) {
      $modelCheckBoxes.prop("disabled", false);
      $compareBar.removeClass("in-view");
    }
  }
  function updateText() {
    if (itemsAddedToCompareBar < 2) {
      $(".compareComponent-compareSpan").addClass("active");
      $(".compareComponent-compareLink").removeClass("active");
    } else {
      $(".compareComponent-compareSpan").removeClass("active");
      $(".compareComponent-compareLink").addClass("active");
    }
  }
  function openCompareView() {
    clearAllItemsFromCompareBar();
    var url = $(this).attr("href");
    window.location.href = url;
  }
  function updateLink() {
    var url = new URL($compareLink.attr("href"), window.location.origin);
    url.searchParams.set('ids', pimIds);
    $compareLink.attr("href", url.href);
  }
  function addPimIds($modelCheckbox) {
    var id = $modelCheckbox.closest("div[data-pim-id]").data("pim-id");
    pimIds.push(id);
  }
  function removePimIds($checkbox) {
    var id = $checkbox.parent("[data-pim-id]").data("pim-id");
    pimIds.splice($.inArray(id, pimIds), 1);
  }
  function addItemToCompareBar($modelCheckbox) {
    var $parentModel = $modelCheckbox.parent(),
      imageUrl = $parentModel.data("image-url"),
      imageAlt = $parentModel.data("image-alt"),
      pimId = $parentModel.data("pim-id"),
      publicationName = $parentModel.data("publication-name"),
      $firstAvailableListItem = $(".compareComponent-list li:not(.has-model):first");
    $firstAvailableListItem.addClass("has-model").attr("data-pim-id", pimId).find("div").append("<img src='" + imageUrl + "' alt='" + imageAlt + "' class='compareComponent-image' />" + "<p class='compareComponent-publicationName u-textBold16'>" + publicationName + "</p>" + "<span><svg class='compareComponent-itemClear' viewBox='0 0 30 30'>" + "<path d='M20.1 23.9L15 18.8l-5.1 5.1-3.8-3.8 5.1-5.1-5.1-5.1 3.8-3.8 5.1 5.1 5.1-5.1 3.8 3.8-5.1 5.1 5.1 5.1z' />" + "</svg></span>");
  }
});